import styles from "./BillingToggle.module.css";

const BillingToggle = ({ selected, setSelected, t, discountPercent, loadingPlan }) => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.toggle}>
        <button disabled={loadingPlan} onClick={() => setSelected("monthly")} className={`${styles.button} ${selected === "monthly" ? styles.active : ""}`}>
          {t("subscription_billing_monthly")}
        </button>

        <button disabled={loadingPlan} onClick={() => setSelected("yearly")} className={`${styles.button} ${selected === "yearly" ? styles.active : ""}`}>
          {t("subscription_billing_yearly")}
          {discountPercent > 0 && (
            <span className={`${styles.badge} ${selected === "yearly" ? styles.badgeActive : ""}`}>-{discountPercent}%</span>
          )}
        </button>
      </div>
    </div>
  );
};

export default BillingToggle;